import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanySocietyImpactDto, UpsertSocietyImpactRequest } from '../../models/api/companySocietyImpactDto';
import { YearlyResource } from '../../models/api/yearlyResource';
import { DefaultCurrencyContext } from '../../models/api/defaultCurrencyContext';

@Injectable({
  providedIn: 'root'
})
export class CompanySocietyImpactService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<YearlyResource<CompanySocietyImpactDto, DefaultCurrencyContext>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<CompanySocietyImpactDto, DefaultCurrencyContext>>(
      `${this.apiUrl}/${companyId}/society-impact`,
      { params }
    );
  }

  upsert(companyId: string, request: UpsertSocietyImpactRequest): Observable<CompanySocietyImpactDto> {
    return this.http.put<CompanySocietyImpactDto>(`${this.apiUrl}/${companyId}/society-impact`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/society-impact`, { params });
  }
}
